
// Make a scrollbarWidth custom property
const scrollbarWidth = window.innerWidth - document.body.clientWidth;
document.body.style.setProperty("--scroll-bar-width", `${scrollbarWidth}px`);
